export const PLAN_TIER = {
	FREE: 'free',
	PRO: 'pro',
};

export function getProSlug(freeSlug) {
	if (!freeSlug) {
		return '';
	}

	return `${freeSlug}-pro`;
}

export function normalizePluginSlug(slug = '') {
	return String(slug).toLowerCase().trim();
}

export function matchesPluginSlug(pluginSlug, targetSlug) {
	if (!pluginSlug || !targetSlug) {
		return false;
	}

	const plugin = normalizePluginSlug(pluginSlug);
	const target = normalizePluginSlug(targetSlug);

	return plugin === target || plugin.endsWith(`/${target}`);
}

export function matchesProPluginSlug(pluginSlug, freeSlug, proSlug) {
	if (!pluginSlug || !freeSlug) {
		return false;
	}

	const resolvedProSlug = proSlug || getProSlug(freeSlug);

	if (matchesPluginSlug(pluginSlug, resolvedProSlug)) {
		return true;
	}

	const plugin = normalizePluginSlug(pluginSlug);
	const base = normalizePluginSlug(freeSlug);

	if (!plugin.endsWith('-pro')) {
		return false;
	}

	return plugin === `${base}-pro` || plugin.startsWith(`${base}-`);
}

export function isActivePlugin(plugin) {
	return normalizePluginSlug(plugin?.state) === 'active';
}

/**
 * Resolve free vs pro from siteplugins rows for the current Telemetry product.
 */
export function resolvePlanTierFromPlugins(plugins, freeSlug, proSlug) {
	if (!freeSlug || !Array.isArray(plugins) || plugins.length === 0) {
		return null;
	}

	const resolvedProSlug = proSlug || getProSlug(freeSlug);
	const activePlugins = plugins.filter(isActivePlugin);

	const hasPro = activePlugins.some((plugin) =>
		matchesProPluginSlug(plugin.slug, freeSlug, resolvedProSlug)
	);

	if (hasPro) {
		return PLAN_TIER.PRO;
	}

	const hasFree = activePlugins.some((plugin) =>
		matchesPluginSlug(plugin.slug, freeSlug)
	);

	if (hasFree) {
		return PLAN_TIER.FREE;
	}

	return null;
}

export function rollupPlanTiers(tiers) {
	if (!Array.isArray(tiers) || tiers.length === 0) {
		return null;
	}

	if (tiers.includes(PLAN_TIER.PRO)) {
		return PLAN_TIER.PRO;
	}

	if (tiers.includes(PLAN_TIER.FREE)) {
		return PLAN_TIER.FREE;
	}

	return null;
}
